import React, { useRef } from "react";
import { SPACING, PaddedContainer } from "@disco/disco_core";

import useWidgetOffer from "../../hooks/useWidgetOffer";
import useDimensions from "../../hooks/useDimensions";
import useElementInView from "../../hooks/useElementInView";
import useCachedViewTrack, {
	TRACKED_TARGET,
} from "../../hooks/useCachedViewTrack";
import useImpression from "../../hooks/useImpression";
import { eventTypes } from "../../hooks/useTrack";
import { BRAND_CLICK_TARGET } from "../../event_conf";
import { SNOWPLOW_EVENT } from "../../utils/snowplowEventMigrator";
import EngageOfferFooter from "./EngageOfferFooter";
import EngageOfferInfo from "./EngageOfferInfo";
import EngageOfferImage from "./EngageOfferImage";

const EngageOfferSlot = ({ setShouldRenderOffersSlot }) => {
	const { isLargeWidget } = useDimensions();
	const { activeOffer, defaultOfferEventProps } = useWidgetOffer();
	const brandContainerRef = useRef(null);
	const { isPartiallyInView } = useElementInView({
		elementRef: brandContainerRef,
	});

	const { id: brandId } = activeOffer || {};

	useCachedViewTrack({
		id: brandId,
		key: TRACKED_TARGET.BRAND,
		event: eventTypes.WIDGET_BRAND_DISPLAY,
		properties: {
			...defaultOfferEventProps,
			initiatingTarget: BRAND_CLICK_TARGET.INLINE_COVER_TILE,
		},
		canTrack: isPartiallyInView,
	});

	useImpression({
		id: brandId,
		cacheKey: TRACKED_TARGET.VIEWABLE_THRESHOLD_BRAND,
		event: SNOWPLOW_EVENT.WIDGET_VIEWABLE_THRESHOLD_BRAND_DISPLAY,
		properties: {
			...defaultOfferEventProps,
			initiatingTarget: BRAND_CLICK_TARGET.INLINE_COVER_TILE,
		},
		target: brandContainerRef.current,
	});

	return (
		<PaddedContainer
			vPadding={SPACING.REGULAR}
			hPadding={SPACING.REGULAR}
			ref={brandContainerRef}
			key={brandId}
			data-intersectionuid={brandId} // for useImpression Tracking
		>
			<PaddedContainer
				style={{
					display: "flex",
					alignItems: "center",
					gap: "var(--disco-spacing-sm)",
				}}
			>
				<EngageOfferImage />

				{isLargeWidget ? (
					<PaddedContainer
						style={{
							flexGrow: 1,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
						}}
					>
						<EngageOfferInfo />
						<PaddedContainer marginTop={SPACING.TINY}>
							<EngageOfferFooter
								setShouldRenderOffersSlot={
									setShouldRenderOffersSlot
								}
							/>
						</PaddedContainer>
					</PaddedContainer>
				) : (
					<EngageOfferInfo />
				)}
			</PaddedContainer>

			{!isLargeWidget && (
				<PaddedContainer marginTop={SPACING.SMALL}>
					<EngageOfferFooter
						setShouldRenderOffersSlot={setShouldRenderOffersSlot}
					/>
				</PaddedContainer>
			)}
		</PaddedContainer>
	);
};

export default EngageOfferSlot;
